import * as amplitude from '@amplitude/analytics-browser'


export const trackPLPFilterChange = (location: any) => {
	const searchParams = new URLSearchParams(location.search)
	const pathParts = location.pathname.split('/')

	const eventData = {
		ageGroup: searchParams.get('ageGroup') || '',
		brands: searchParams.getAll('brand').join(', ') || '',
		category: pathParts.pop() || '', // Assuming the category is part of the URL path
		colours: searchParams.getAll('color').join(', ') || '',
		gender: searchParams.get('gender') || '',
		sizes: searchParams.getAll('size').join(', ') || '',
		Material: searchParams.getAll('materials').join(', ') || '',
		sortingOrder: searchParams.get('sortingOrder') || '',
	}

	amplitude.track('PLP Filter Change', eventData)
}